import(/* webpackMode: "eager" */ "/app/apps/customer-web/src/app/global-error.tsx");
